/* istanbul ignore file */
import { HorizontalMenu } from 'framework/ui/menu';
import React from 'react';
import { NewCompetencyTypeLabels } from 'domain/people/career/qualification/newCompetency/newCompetencyService';
import { Button } from 'framework/ui/mui-builder';

const NewQualificationMenu = ({ currentType, setCurrentType }: { currentType: string; setCurrentType: any }) => {
  return (
    <HorizontalMenu sx={{ mt: 2, pt: 0 }}>
      {Object.entries(NewCompetencyTypeLabels).map(entry => {
        const [value, label] = entry;
        return (
          <Button
            key={`horizontal-menu-item-${value}`}
            color="primary"
            className={`horizontal-menu-btn ${value === currentType ? 'horizontal-menu-btn--active' : ''}`}
            onClick={() => setCurrentType(value)}
          >
            {label}
          </Button>
        );
      })}
    </HorizontalMenu>
  );
};

export default NewQualificationMenu;
